<header #header>
    <ng-content select="app-toolbar"></ng-content>
</header>
